// src/admin/pages/AdminLoginPage.tsx
import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
  Alert,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useMutation } from "@apollo/client";
import { ADMIN_LOGIN_MUTATION } from "../../graphql/adminAuth";
import { setAdminToken } from "../../auth";
import { useNavigate } from "react-router-dom";
import AdminLoading from "../Components/AdminLoading";

const AdminLoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const [adminLogin, { loading }] = useMutation(ADMIN_LOGIN_MUTATION, {
    onCompleted: (data) => {
      const payload = data?.signIn;
      if (payload?.token) {
        setAdminToken(payload.token);
        navigate("/admin", { replace: true });
      } else {
        setError(payload?.errors?.join(", ") || "Invalid credentials");
      }
    },
    onError: (err) => setError(err.message),
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    adminLogin({ variables: { email, password } });
  };

  return (
    <>
      <AdminLoading open={loading} />

      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          px: 2,
        }}
      >
        <Container maxWidth="xs">
          <Paper sx={{ p: 4 }}>
            <Typography variant="h5" align="center" mb={2}>
              Admin Login
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              {/*  Password With Eye Icon */}
              <TextField
                fullWidth
                label="Password"
                type={showPassword ? "text" : "password"}
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                fullWidth
                type="submit"
                variant="contained"
                sx={{ mt: 2 }}
              >
                Login
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default AdminLoginPage;
